import { Action } from 'redux'
import { IFormValues } from '../../../containers/Form/CreateRoom'
import { IRoom } from '../../../models/Room'
import { RoomActions } from '../../../reducers/bookingCalendar/actionNames'

const requestUpdateRoom = (
  roomId: string,
  room: IFormValues,
  formName: string,
): IRequestUpdateRoom => ({
  formName,
  room,
  roomId,
  type: RoomActions.RequestUpdateRoom,
})

export interface IRequestUpdateRoom
  extends Action<RoomActions.RequestUpdateRoom> {
  roomId?: string
  room: IFormValues
  formName: string
}

const roomWasUpdated = (room: IRoom): IRoomWasUpdated => ({
  room,
  type: RoomActions.RoomWasUpdated,
})
const requestNextRoom = (roomId): IRequestNextRoom => ({
  roomId,
  type: RoomActions.RequestNext,
})
const requestPrevRoom = (roomId): IRequestPrevRoom => ({
  roomId,
  type: RoomActions.RequestPrev,
})

export interface IRoomWasUpdated extends Action<RoomActions.RoomWasUpdated> {
  room: IRoom
}

export interface IRequestPrevRoom extends Action<RoomActions.RequestPrev> {
  roomId: string
}

export interface IRequestNextRoom extends Action<RoomActions.RequestNext> {
  roomId: string
}

export { roomWasUpdated, requestNextRoom, requestPrevRoom }
export default requestUpdateRoom
